(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[662],{

/***/ 56227:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ BackButtonBar; },
/* harmony export */   "x": function() { return /* binding */ BackButton; }
/* harmony export */ });
/* harmony import */ var app_hooks_lang__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91289);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86010);
/* harmony import */ var _icons_ArrowBack__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40774);
/* harmony import */ var _back_button_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71345);
/* harmony import */ var _back_button_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_back_button_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);






var BackButtonBar = function BackButtonBar(_ref) {
  var onClick = _ref.onClick,
      className = _ref.className,
      buttonClassName = _ref.buttonClassName;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
    "data-navigate-row": true,
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((_back_button_module_scss__WEBPACK_IMPORTED_MODULE_3___default().wrapper), className),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BackButton, {
      onClick: onClick,
      className: buttonClassName
    })
  });
};
var BackButton = function BackButton(_ref2) {
  var onClick = _ref2.onClick,
      className = _ref2.className;
  var t = (0,app_hooks_lang__WEBPACK_IMPORTED_MODULE_4__/* .useTranslate */ .q)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("button", {
    "data-navigate-item": true,
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((_back_button_module_scss__WEBPACK_IMPORTED_MODULE_3___default().back), className),
    onClick: onClick,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_icons_ArrowBack__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
      children: t("back")
    })]
  });
};

/***/ }),

/***/ 48778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P": function() { return /* binding */ CountrySelector; }
});

// EXTERNAL MODULE: ./app/hooks/go-back.hook.ts
var go_back_hook = __webpack_require__(71014);
// EXTERNAL MODULE: ./app/hooks/keyboard-navigation.hook.ts
var keyboard_navigation_hook = __webpack_require__(36158);
// EXTERNAL MODULE: ./app/hooks/modal-scroll.hook.ts
var modal_scroll_hook = __webpack_require__(76299);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./services-hooks/hooks.ts + 1 modules
var hooks = __webpack_require__(90413);
// EXTERNAL MODULE: ./app/components/back-button/back-button.component.tsx
var back_button_component = __webpack_require__(56227);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./app/components/country-list/country-list.module.scss
var country_list_module = __webpack_require__(46652);
var country_list_module_default = /*#__PURE__*/__webpack_require__.n(country_list_module);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./app/components/icons/Logo.tsx
var Logo = __webpack_require__(23583);
// EXTERNAL MODULE: ./app/components/icons/ArrowRight.tsx
var ArrowRight = __webpack_require__(8426);
// EXTERNAL MODULE: ./app/context/features.context.tsx
var features_context = __webpack_require__(10833);
// EXTERNAL MODULE: ./app/utils/scroll.ts
var utils_scroll = __webpack_require__(21278);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./app/components/country-list/country-list.component.tsx













var CountryList = function CountryList(_ref) {
  var regionPermalink = _ref.regionPermalink,
      label = _ref.label,
      wrapped = _ref.wrapped,
      className = _ref.className,
      _ref$showNames = _ref.showNames,
      showNames = _ref$showNames === void 0 ? false : _ref$showNames,
      onSelect = _ref.onSelect;
  var radioListRef = (0,react.useRef)(null);

  var _useFeaturesContext = (0,features_context/* useFeaturesContext */.Pp)(),
      arrowNavigationEnabled = _useFeaturesContext.arrowNavigationEnabled;

  var _useGetPillowCategory = (0,hooks/* useGetPillowCategoryPath */.gn)(regionPermalink, {
    pageSize: 100
  }),
      data = _useGetPillowCategory.data,
      isLoading = _useGetPillowCategory.isLoading,
      fetchNextPage = _useGetPillowCategory.fetchNextPage;

  var countryList = (data === null || data === void 0 ? void 0 : data.pages.reduce(function (countryList, countryPage) {
    var _countryPage$data$bod;

    return [].concat((0,toConsumableArray/* default */.Z)(countryList), (0,toConsumableArray/* default */.Z)(((_countryPage$data$bod = countryPage.data.body) === null || _countryPage$data$bod === void 0 ? void 0 : _countryPage$data$bod.content) || []));
  }, [])) || [];

  var onForward = function onForward() {
    var _radioListRef$current;

    (_radioListRef$current = radioListRef.current) === null || _radioListRef$current === void 0 ? void 0 : _radioListRef$current.scrollTo({
      left: (0,utils_scroll/* calculateCountryListScroll */.xF)(radioListRef.current.scrollLeft),
      behavior: "smooth"
    });
  };

  var onBackward = function onBackward() {
    var _radioListRef$current2;

    (_radioListRef$current2 = radioListRef.current) === null || _radioListRef$current2 === void 0 ? void 0 : _radioListRef$current2.scrollTo({
      left: (0,utils_scroll/* calculateCountryListScroll */.xF)(radioListRef.current.scrollLeft, true),
      behavior: "smooth"
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (0,clsx_m/* default */.Z)((country_list_module_default()).wrapper, className),
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (country_list_module_default()).header,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
        children: label
      }), !arrowNavigationEnabled && !wrapped && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (country_list_module_default()).buttons,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          className: (0,clsx_m/* default */.Z)((country_list_module_default()).arrow, (country_list_module_default()).arrow_back),
          onClick: function onClick() {
            return onBackward();
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ArrowRight/* default */.Z, {})
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          className: (country_list_module_default()).arrow,
          onClick: function onClick() {
            return onForward();
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ArrowRight/* default */.Z, {})
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (country_list_module_default()).radio_list,
      ref: radioListRef,
      children: isLoading ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (country_list_module_default()).row,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (0,clsx_m/* default */.Z)((country_list_module_default()).radio_station, (country_list_module_default()).placeholder_item)
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (0,clsx_m/* default */.Z)((country_list_module_default()).radio_station, (country_list_module_default()).placeholder_item)
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (0,clsx_m/* default */.Z)((country_list_module_default()).radio_station, (country_list_module_default()).placeholder_item)
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (0,clsx_m/* default */.Z)((country_list_module_default()).radio_station, (country_list_module_default()).placeholder_item)
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (0,clsx_m/* default */.Z)((country_list_module_default()).radio_station, (country_list_module_default()).placeholder_item)
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (0,clsx_m/* default */.Z)((country_list_module_default()).radio_station, (country_list_module_default()).placeholder_item)
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (0,clsx_m/* default */.Z)((country_list_module_default()).radio_station, (country_list_module_default()).placeholder_item)
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (0,clsx_m/* default */.Z)((country_list_module_default()).radio_station, (country_list_module_default()).placeholder_item)
        })]
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)((country_list_module_default()).row, (0,defineProperty/* default */.Z)({}, (country_list_module_default()).wrapped, wrapped)),
        "data-navigate-row": true,
        "data-navigate-scrollable": true,
        "data-navigate-scrollable-parent": true,
        children: countryList.map(function (country, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            "data-navigate-item": true,
            tabIndex: 0,
            className: (0,clsx_m/* default */.Z)((country_list_module_default()).radio_station, (0,defineProperty/* default */.Z)({}, (country_list_module_default()).show_station_names, showNames)),
            onClick: function onClick() {
              return onSelect(country);
            },
            children: [country !== null && country !== void 0 && country.logo ? /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              src: (country === null || country === void 0 ? void 0 : country.logo) || "",
              layout: "intrinsic",
              width: 102,
              className: (country_list_module_default()).cover,
              height: 102,
              objectFit: "cover",
              alt: "",
              unoptimized: true
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (0,clsx_m/* default */.Z)((country_list_module_default()).cover, (country_list_module_default()).no_image),
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Logo/* default */.Z, {})
            }), showNames && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (country_list_module_default()).station_title,
              children: country.name
            })]
          }, "country-".concat(index));
        })
      })
    })]
  });
};
// EXTERNAL MODULE: ./app/components/icons/Loader.tsx
var Loader = __webpack_require__(37387);
// EXTERNAL MODULE: ./app/components/country-selector/country-selector.module.scss
var country_selector_module = __webpack_require__(42665);
var country_selector_module_default = /*#__PURE__*/__webpack_require__.n(country_selector_module);
;// CONCATENATED MODULE: ./app/components/country-selector/country-selector.component.tsx












var CountrySelector = function CountrySelector(_ref) {
  var onClose = _ref.onClose,
      onSelect = _ref.onSelect;
  var wrapperRef = (0,keyboard_navigation_hook/* useArrowKeyNavigationOverlay */.Sy)();
  var loadMoreTriggerRef = (0,react.useRef)(null);

  var _useGetPillowCategori = (0,hooks/* useGetPillowCategoriesPath */.Bs)("/radioline_geo", {
    pageSize: 100
  }),
      data = _useGetPillowCategori.data,
      isLoading = _useGetPillowCategori.isLoading,
      fetchNextPage = _useGetPillowCategori.fetchNextPage;

  (0,modal_scroll_hook/* default */.Z)();
  var goBackCallback = (0,react.useCallback)(function () {
    onClose();
  }, [onClose]);
  (0,go_back_hook/* useGoBackEvent */.H)("CountrySelector", goBackCallback);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (country_selector_module_default()).wrapper,
    ref: wrapperRef,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(back_button_component/* BackButtonBar */.K, {
      onClick: onClose
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (country_selector_module_default()).content,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (country_selector_module_default()).countries_wrapper,
        children: isLoading ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (country_selector_module_default()).loader_container,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Loader/* default */.Z, {})
        }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [data === null || data === void 0 ? void 0 : data.pages.map(function (countryPage) {
            var _countryPage$data$bod, _countryPage$data$bod2;

            return (_countryPage$data$bod = countryPage.data.body) === null || _countryPage$data$bod === void 0 ? void 0 : (_countryPage$data$bod2 = _countryPage$data$bod.content) === null || _countryPage$data$bod2 === void 0 ? void 0 : _countryPage$data$bod2.map(function (countryRegion) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(CountryList, {
                regionPermalink: countryRegion.permalink,
                label: countryRegion.name,
                showNames: true,
                onSelect: onSelect
              });
            });
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            ref: loadMoreTriggerRef
          })]
        })
      })
    })]
  });
};

/***/ }),

/***/ 40774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var ArrowBack = function ArrowBack(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("svg", _objectSpread(_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 60 60",
    fill: "none"
  }, props), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M50 27.5H19.575L33.55 13.525 30 10 10 30l20 20 3.525-3.525L19.575 32.5H50v-5z",
      fill: "#fff"
    })
  }));
};

var MemoArrowBack = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(ArrowBack);
/* harmony default export */ __webpack_exports__["Z"] = (MemoArrowBack);

/***/ }),

/***/ 8426:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var ArrowRight = function ArrowRight(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("svg", _objectSpread(_objectSpread({
    fill: "none",
    height: "1em",
    viewBox: "0 0 40 40",
    width: "1em"
  }, props), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
      stroke: "#fff",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("circle", {
        cx: 20,
        cy: 20,
        r: 19.431,
        strokeOpacity: 0.15,
        strokeWidth: 1.137,
        transform: "rotate(180 20 20)"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M18.235 14.117L24.118 20l-5.883 5.883",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.961
      })]
    })
  }));
};

var MemoArrowRight = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(ArrowRight);
/* harmony default export */ __webpack_exports__["Z"] = (MemoArrowRight);

/***/ }),

/***/ 31549:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var app_hooks_lang__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91289);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);



var useMetaDescription = function useMetaDescription() {
  var t = (0,app_hooks_lang__WEBPACK_IMPORTED_MODULE_1__/* .useTranslate */ .q)();
  return function (text) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
      name: "description",
      content: text || t("meta.description")
    });
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (useMetaDescription);

/***/ }),

/***/ 26089:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "vl": function() { return /* binding */ useIsLargeDesktopResolution; },
  "zO": function() { return /* binding */ useIsMobileResolution; }
});

// UNUSED EXPORTS: useIsSmallDesktopResolution

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-use/esm/misc/util.js
var util = __webpack_require__(76362);
;// CONCATENATED MODULE: ./node_modules/react-use/esm/useMedia.js


var getInitialState = function (query, defaultState) {
    // Prevent a React hydration mismatch when a default value is provided by not defaulting to window.matchMedia(query).matches.
    if (defaultState !== undefined) {
        return defaultState;
    }
    if (util/* isBrowser */.jU) {
        return window.matchMedia(query).matches;
    }
    // A default value has not been provided, and you are rendering on the server, warn of a possible hydration mismatch when defaulting to false.
    if (false) {}
    return false;
};
var useMedia_useMedia = function (query, defaultState) {
    var _a = (0,react.useState)(getInitialState(query, defaultState)), state = _a[0], setState = _a[1];
    (0,react.useEffect)(function () {
        var mounted = true;
        var mql = window.matchMedia(query);
        var onChange = function () {
            if (!mounted) {
                return;
            }
            setState(!!mql.matches);
        };
        mql.addListener(onChange);
        setState(mql.matches);
        return function () {
            mounted = false;
            mql.removeListener(onChange);
        };
    }, [query]);
    return state;
};
/* harmony default export */ var esm_useMedia = (useMedia_useMedia);

;// CONCATENATED MODULE: ./app/utils/is-mobile-resolution.ts

var useIsMobileResolution = function useIsMobileResolution() {
  return esm_useMedia('(max-width: 768px)');
};
var useIsSmallDesktopResolution = function useIsSmallDesktopResolution() {
  return useMedia('(max-width: 1281px)');
};
var useIsLargeDesktopResolution = function useIsLargeDesktopResolution() {
  return esm_useMedia('(min-width: 1920px)');
};

/***/ }),

/***/ 21278:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HE": function() { return /* binding */ calculateCategoryScroll; },
/* harmony export */   "R$": function() { return /* binding */ calculateRadioScroll; },
/* harmony export */   "_7": function() { return /* binding */ calculatePodcastScroll; },
/* harmony export */   "xF": function() { return /* binding */ calculateCountryListScroll; }
/* harmony export */ });
/* unused harmony export getFontSizeMultiplier */
/* harmony import */ var _components_stations_list_stations_list_module_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98215);
/* harmony import */ var _components_stations_list_stations_list_module_scss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_components_stations_list_stations_list_module_scss__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _components_podcats_list_podcast_list_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93646);
/* harmony import */ var _components_podcats_list_podcast_list_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_components_podcats_list_podcast_list_module_scss__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_category_list_category_list_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52986);
/* harmony import */ var _components_category_list_category_list_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_components_category_list_category_list_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _components_country_list_country_list_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46652);
/* harmony import */ var _components_country_list_country_list_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_components_country_list_country_list_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_variables_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80792);
/* harmony import */ var _styles_variables_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_variables_module_scss__WEBPACK_IMPORTED_MODULE_4__);





var getFontSizeMultiplier = function getFontSizeMultiplier() {
  return window.innerWidth >= 3840 ? 1.6 : window.innerWidth >= 2560 ? 1.12 : 1;
};

var getRadioStationBoxWidth = function getRadioStationBoxWidth() {
  return Number(_components_stations_list_stations_list_module_scss__WEBPACK_IMPORTED_MODULE_0___default().radioStationOuterWidth.replace('rem', '')) * 10 * getFontSizeMultiplier();
};

var getRadioStationBoxWidthMobile = function getRadioStationBoxWidthMobile() {
  return Number(_components_stations_list_stations_list_module_scss__WEBPACK_IMPORTED_MODULE_0___default().radioStationOuterWidthMobile.replace('rem', '')) * 10 * getFontSizeMultiplier();
};

var getPodcastBoxWidth = function getPodcastBoxWidth() {
  return Number(_components_podcats_list_podcast_list_module_scss__WEBPACK_IMPORTED_MODULE_1___default().podcastOuterWidth.replace('rem', '')) * 10 * getFontSizeMultiplier();
};

var getCountryWidth = function getCountryWidth() {
  return Number(_components_country_list_country_list_module_scss__WEBPACK_IMPORTED_MODULE_2___default().countryWidth.replace('rem', '')) * 10 * getFontSizeMultiplier();
};

var getCategoryBoxWidth = function getCategoryBoxWidth() {
  return Number(_components_category_list_category_list_module_scss__WEBPACK_IMPORTED_MODULE_3___default().categoryOuterWidth.replace('rem', '')) * 10 * getFontSizeMultiplier();
};

var getContentMaxWidth = function getContentMaxWidth() {
  return (Number(_styles_variables_module_scss__WEBPACK_IMPORTED_MODULE_4___default().contentMaxWidth.replace('rem', '')) - 4) * 10 * getFontSizeMultiplier();
};

var getPadding = function getPadding() {
  if (window.innerWidth < 421) {
    return 0;
  }

  if (window.innerWidth < 1025) {
    return 32;
  }

  return 50;
};

var getRadioWidth = function getRadioWidth(isMobile) {
  return isMobile ? getRadioStationBoxWidthMobile() : getRadioStationBoxWidth();
};

var calculateRadioScroll = function calculateRadioScroll(scrollLeft) {
  var substract = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var isMobile = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var radioStationWidth = getRadioWidth(isMobile);
  var windowWidth = window.innerWidth - getPadding();
  var startWidth = substract ? scrollLeft - windowWidth : scrollLeft + windowWidth;
  var radioItemsVisible = startWidth / radioStationWidth;
  return startWidth - (radioItemsVisible - Math.floor(radioItemsVisible)) * radioStationWidth;
};
var calculatePodcastScroll = function calculatePodcastScroll(scrollLeft) {
  var substract = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var isMobile = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var podcastWidth = getPodcastBoxWidth();
  var scrollWidth = window.innerWidth - getPadding();
  var startWidth = substract ? scrollLeft - scrollWidth : scrollLeft + scrollWidth;
  var podcastItemsVisible = startWidth / podcastWidth;
  return startWidth - (podcastItemsVisible - Math.floor(podcastItemsVisible)) * podcastWidth;
};
var calculateCountryListScroll = function calculateCountryListScroll(scrollLeft) {
  var substract = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var isMobile = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var countryWidth = getCountryWidth();
  var maxContentWidth = getContentMaxWidth();
  var scrollWidth = window.innerWidth > maxContentWidth ? maxContentWidth : window.innerWidth - getPadding();
  var startWidth = substract ? scrollLeft - scrollWidth : scrollLeft + scrollWidth;
  var countryItemsVisible = startWidth / countryWidth;
  return startWidth - (countryItemsVisible - Math.floor(countryItemsVisible)) * countryWidth;
};
var calculateCategoryScroll = function calculateCategoryScroll(scrollLeft) {
  var substract = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var categoryBoxWidth = getCategoryBoxWidth();
  var windowWidth = window.innerWidth - getPadding();
  var startWidth = substract ? scrollLeft - windowWidth : scrollLeft + windowWidth;
  return startWidth - (startWidth / categoryBoxWidth - Math.floor(startWidth / categoryBoxWidth)) * categoryBoxWidth;
};

/***/ }),

/***/ 74904:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ settings; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./app/components/ui/button.component.tsx
var button_component = __webpack_require__(61947);
// EXTERNAL MODULE: ./app/context/auth.context.tsx
var auth_context = __webpack_require__(92862);
// EXTERNAL MODULE: ./app/store/slices/user.ts
var user = __webpack_require__(38886);
// EXTERNAL MODULE: ./app/store/store.ts
var store = __webpack_require__(4062);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./pages/settings.module.scss
var settings_module = __webpack_require__(70844);
var settings_module_default = /*#__PURE__*/__webpack_require__.n(settings_module);
// EXTERNAL MODULE: ./services-hooks/hooks.ts + 1 modules
var hooks = __webpack_require__(90413);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./app/components/ui/toggle.module.scss
var toggle_module = __webpack_require__(13937);
var toggle_module_default = /*#__PURE__*/__webpack_require__.n(toggle_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./app/components/ui/toggle.component.tsx


var _excluded = ["small", "reverse", "disabled", "className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var Toggle = /*#__PURE__*/react.forwardRef(function (_ref, ref) {
  var _clsx;

  var _ref$small = _ref.small,
      small = _ref$small === void 0 ? false : _ref$small,
      _ref$reverse = _ref.reverse,
      reverse = _ref$reverse === void 0 ? false : _ref$reverse,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      className = _ref.className,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (0,clsx_m/* default */.Z)((toggle_module_default()).toggle_wrapper, (_clsx = {}, (0,defineProperty/* default */.Z)(_clsx, (toggle_module_default()).small, small), (0,defineProperty/* default */.Z)(_clsx, (toggle_module_default()).reverse, reverse), (0,defineProperty/* default */.Z)(_clsx, (toggle_module_default()).disabled, disabled), _clsx), className),
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
      className: (toggle_module_default()).toggle,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", _objectSpread({
        type: "checkbox",
        ref: ref,
        disabled: disabled
      }, props)), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: (toggle_module_default()).slider
      })]
    }), props.label && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: (toggle_module_default()).toggle_text,
      children: props.label
    })]
  });
});
Toggle.displayName = "Toggle";
;// CONCATENATED MODULE: ./app/components/icons/AngleRight.tsx


function AngleRight_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function AngleRight_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? AngleRight_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : AngleRight_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var AngleRight = function AngleRight(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", AngleRight_objectSpread(AngleRight_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 27",
    fill: "none"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      opacity: 0.5,
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 3.15L3.027 0 16 13.5 3.027 27 0 23.85 9.946 13.5 0 3.15z",
      fill: "#fff"
    })
  }));
};

var MemoAngleRight = /*#__PURE__*/react.memo(AngleRight);
/* harmony default export */ var icons_AngleRight = (MemoAngleRight);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./app/context/features.context.tsx
var features_context = __webpack_require__(10833);
// EXTERNAL MODULE: ./app/context/country.context.tsx
var country_context = __webpack_require__(91537);
// EXTERNAL MODULE: ./app/components/country-selector/country-selector.component.tsx + 1 modules
var country_selector_component = __webpack_require__(48778);
;// CONCATENATED MODULE: ./app/components/icons/Deezer.tsx


function Deezer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Deezer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Deezer_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Deezer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var Deezer = function Deezer(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", Deezer_objectSpread(Deezer_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 95 19",
    fill: "none"
  }, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M22.138 12c0 3.793 2.335 6.063 5.806 6.063 1.73 0 3.187-.483 4-1.75v1.75h3.168V0h-3.29v7.679c-.748-1.267-2.128-1.835-3.859-1.835-3.385-.01-5.825 2.308-5.825 6.157zm9.787 0c0 2.166-1.475 3.519-3.243 3.519-1.835 0-3.244-1.353-3.244-3.518 0-2.204 1.419-3.584 3.244-3.584 1.768 0 3.244 1.4 3.244 3.584zm13.43 1.4c-.38 1.4-1.334 2.1-2.838 2.1-1.75 0-3.187-1.06-3.225-2.932h8.294c.104-.463.151-.955.151-1.494 0-3.357-2.288-5.249-5.664-5.249-3.603 0-6.081 2.563-6.081 6.043 0 3.878 2.733 6.204 6.516 6.204 2.856 0 4.794-1.192 5.645-3.565L45.354 13.4zm-6.063-3.026c.313-1.352 1.438-2.147 2.79-2.147 1.475 0 2.478.795 2.478 2.043l-.02.104h-5.248zM57.563 13.4c-.378 1.4-1.333 2.1-2.837 2.1-1.75 0-3.187-1.06-3.225-2.932h8.294a6.78 6.78 0 00.151-1.494c0-3.357-2.288-5.249-5.664-5.249-3.604 0-6.081 2.563-6.081 6.043 0 3.878 2.733 6.204 6.516 6.204 2.855 0 4.794-1.192 5.645-3.565L57.563 13.4zm-6.062-3.026c.312-1.352 1.438-2.147 2.79-2.147 1.475 0 2.478.795 2.478 2.043l-.02.104h-5.248zm20.058 7.707v-2.978h-6.913l6.724-6.545V5.835H60.731v2.837h6.497l-6.705 6.572v2.837h11.036zm9.618-4.68C80.798 14.8 79.843 15.5 78.34 15.5c-1.75 0-3.187-1.06-3.225-2.932h8.294a6.78 6.78 0 00.15-1.494c0-3.357-2.288-5.249-5.664-5.249-3.603 0-6.08 2.563-6.08 6.043 0 3.878 2.733 6.204 6.515 6.204 2.856 0 4.795-1.192 5.646-3.565l-2.8-1.107zm-6.062-3.027c.312-1.352 1.437-2.147 2.79-2.147 1.475 0 2.477.795 2.477 2.043l-.019.104h-5.248z",
      fill: "#fff"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.706 5.835h4.057V8.21h-4.057V5.835z",
      fill: "#40AB5D"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.706 9.126h4.057v2.373h-4.057V9.127z",
      fill: "url(#prefix__paint0_linear_6273_10627)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.706 12.417h4.057v2.374h-4.057v-2.374z",
      fill: "url(#prefix__paint1_linear_6273_10627)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 15.708h4.057v2.374H0v-2.374z",
      fill: "url(#prefix__paint2_linear_6273_10627)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.897 15.708h4.057v2.374H4.897v-2.374z",
      fill: "url(#prefix__paint3_linear_6273_10627)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.808 15.708h4.057v2.374H9.808v-2.374z",
      fill: "url(#prefix__paint4_linear_6273_10627)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.706 15.708h4.057v2.374h-4.057v-2.374z",
      fill: "url(#prefix__paint5_linear_6273_10627)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.808 12.417h4.057v2.374H9.808v-2.374z",
      fill: "url(#prefix__paint6_linear_6273_10627)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.897 12.417h4.057v2.374H4.897v-2.374z",
      fill: "url(#prefix__paint7_linear_6273_10627)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.897 9.126h4.057v2.373H4.897V9.127z",
      fill: "url(#prefix__paint8_linear_6273_10627)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M91.362 10.063v.35h3.206v-.937c0-2.1-1.315-3.622-3.518-3.622-1.419 0-2.421.69-2.941 1.835V5.854h-3.31v12.228h3.31v-7.878c0-1.248.671-1.938 1.702-1.938.946.01 1.55.898 1.55 1.796z",
      fill: "#fff"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("defs", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "prefix__paint0_linear_6273_10627",
        x1: 16.755,
        y1: 11.52,
        x2: 16.716,
        y2: 9.091,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#358C7B"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 0.526,
          stopColor: "#33A65E"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "prefix__paint1_linear_6273_10627",
        x1: 14.646,
        y1: 14.669,
        x2: 18.825,
        y2: 12.54,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#222B90"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#367B99"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "prefix__paint2_linear_6273_10627",
        x1: 0.001,
        y1: 16.896,
        x2: 4.054,
        y2: 16.896,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#F90"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#FF8000"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "prefix__paint3_linear_6273_10627",
        x1: 4.902,
        y1: 16.896,
        x2: 8.956,
        y2: 16.896,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#FF8000"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#CC1953"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "prefix__paint4_linear_6273_10627",
        x1: 9.806,
        y1: 16.896,
        x2: 13.86,
        y2: 16.896,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#CC1953"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#241284"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "prefix__paint5_linear_6273_10627",
        x1: 14.704,
        y1: 16.896,
        x2: 18.757,
        y2: 16.896,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#222B90"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#3559A6"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "prefix__paint6_linear_6273_10627",
        x1: 9.647,
        y1: 14.244,
        x2: 14.02,
        y2: 12.965,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#CC1953"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#241284"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "prefix__paint7_linear_6273_10627",
        x1: 4.758,
        y1: 12.815,
        x2: 9.1,
        y2: 14.395,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 0.003,
          stopColor: "#FC0"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#CE1938"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "prefix__paint8_linear_6273_10627",
        x1: 5.243,
        y1: 8.757,
        x2: 8.615,
        y2: 11.869,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 0.003,
          stopColor: "#FFD100"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#FD5A22"
        })]
      })]
    })]
  }));
};

var MemoDeezer = /*#__PURE__*/react.memo(Deezer);
/* harmony default export */ var icons_Deezer = (MemoDeezer);
;// CONCATENATED MODULE: ./app/components/icons/Spotify.tsx


function Spotify_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Spotify_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Spotify_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Spotify_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var Spotify = function Spotify(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", Spotify_objectSpread(Spotify_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 98 29",
    fill: "none"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M14.696 0C6.58 0 0 6.492 0 14.5 0 22.51 6.58 29 14.696 29c8.118 0 14.697-6.491 14.697-14.5 0-8.008-6.58-14.5-14.697-14.5zm6.74 20.913a.907.907 0 01-.567.408.929.929 0 01-.693-.108c-3.45-2.08-7.794-2.55-12.91-1.398a.927.927 0 01-.691-.116.905.905 0 01-.416-.917.895.895 0 01.373-.585.922.922 0 01.326-.144c5.599-1.262 10.4-.719 14.274 1.617a.897.897 0 01.304 1.243zm1.799-3.948c-.332.532-1.037.7-1.576.373-3.95-2.396-9.972-3.09-14.645-1.69a1.15 1.15 0 01-1.43-.754 1.119 1.119 0 01.087-.86c.143-.265.387-.462.677-.55 5.338-1.598 11.973-.823 16.51 1.927.538.327.708 1.023.377 1.554zm.154-4.111c-4.736-2.776-12.551-3.031-17.073-1.677a1.378 1.378 0 01-1.715-.904 1.34 1.34 0 01.104-1.033c.171-.317.464-.554.813-.659 5.19-1.554 13.82-1.254 19.274 1.94a1.367 1.367 0 01.631.83 1.338 1.338 0 01-.15 1.028 1.385 1.385 0 01-1.884.475zm16.595.532c-2.538-.597-2.989-1.016-2.989-1.897 0-.832.793-1.392 1.974-1.392 1.145 0 2.278.426 3.468 1.3.035.027.08.038.125.03a.166.166 0 00.11-.066l1.24-1.723a.163.163 0 00-.032-.223c-1.416-1.121-3.01-1.666-4.874-1.666-2.74 0-4.654 1.622-4.654 3.943 0 2.49 1.652 3.37 4.505 4.051 2.427.552 2.838 1.014 2.838 1.84 0 .917-.828 1.486-2.162 1.486-1.481 0-2.69-.493-4.042-1.646a.174.174 0 00-.12-.04.165.165 0 00-.115.057l-1.39 1.63c-.058.07-.05.17.016.23a8.345 8.345 0 005.595 2.115c2.951 0 4.859-1.59 4.859-4.055.005-2.079-1.256-3.23-4.347-3.972l-.005-.002zm11.031-2.47c-1.28 0-2.328.498-3.196 1.517v-1.147a.162.162 0 00-.047-.116.167.167 0 00-.117-.049h-2.273a.165.165 0 00-.165.165V24.03c0 .09.074.165.165.165h2.273a.165.165 0 00.164-.165v-4.022c.867.957 1.917 1.427 3.196 1.427 2.378 0 4.786-1.806 4.786-5.259.003-3.453-2.404-5.26-4.784-5.26h-.002zm2.143 5.26c0 1.757-1.097 2.985-2.67 2.985-1.552 0-2.725-1.283-2.725-2.985s1.173-2.985 2.726-2.985c1.546 0 2.669 1.255 2.669 2.985zm8.811-5.26c-3.062 0-5.46 2.327-5.46 5.298 0 2.938 2.382 5.24 5.424 5.24 3.073 0 5.479-2.319 5.479-5.278 0-2.949-2.39-5.26-5.443-5.26zm0 8.262c-1.628 0-2.857-1.291-2.857-3.003 0-1.72 1.187-2.967 2.82-2.967 1.64 0 2.875 1.292 2.875 3.005 0 1.719-1.193 2.965-2.838 2.965zm11.981-8.057h-2.5V8.6a.16.16 0 00-.048-.115.166.166 0 00-.117-.049h-2.273a.166.166 0 00-.167.164v2.522h-1.091a.165.165 0 00-.165.165v1.927c0 .09.073.164.165.164h1.091v4.986c0 2.014 1.017 3.035 3.022 3.035.815 0 1.49-.166 2.127-.523a.16.16 0 00.085-.142v-1.835c0-.056-.03-.11-.08-.139a.162.162 0 00-.16-.007 2.9 2.9 0 01-1.335.317c-.728 0-1.054-.327-1.054-1.058v-4.633h2.5a.165.165 0 00.165-.165v-1.926a.158.158 0 00-.1-.152.163.163 0 00-.063-.012l-.002-.002zm8.712.01v-.31c0-.91.354-1.317 1.148-1.317.474 0 .854.093 1.28.233a.166.166 0 00.218-.156V7.69a.164.164 0 00-.118-.157 6.302 6.302 0 00-1.888-.267c-2.097 0-3.208 1.166-3.208 3.37v.475h-1.091a.166.166 0 00-.167.164v1.937c0 .09.076.164.167.164h1.091v7.689c0 .091.076.164.167.164h2.271a.165.165 0 00.167-.164v-7.689h2.121l3.25 7.689c-.368.806-.731.968-1.226.968-.4 0-.823-.118-1.253-.352a.183.183 0 00-.132-.012.164.164 0 00-.098.088l-.77 1.668a.163.163 0 00.072.213c.803.43 1.528.613 2.425.613 1.678 0 2.606-.773 3.422-2.847l3.941-10.05a.158.158 0 00-.017-.152.16.16 0 00-.135-.071h-2.366a.166.166 0 00-.158.11l-2.423 6.828-2.654-6.832a.167.167 0 00-.154-.106h-3.882zm-5.05-.01h-2.273a.166.166 0 00-.167.165v9.78c0 .091.075.164.167.164h2.272a.166.166 0 00.167-.164v-9.78a.162.162 0 00-.103-.151.171.171 0 00-.064-.014zm-1.124-4.453c-.9 0-1.63.72-1.63 1.607a1.59 1.59 0 00.477 1.138 1.632 1.632 0 001.153.47c.9 0 1.629-.72 1.629-1.608 0-.888-.73-1.607-1.629-1.607zm19.904 7.598a1.582 1.582 0 01-1.598-1.578c0-.865.709-1.586 1.607-1.586.899 0 1.599.713 1.599 1.577 0 .866-.709 1.587-1.608 1.587zm.01-3.007c-.82 0-1.44.643-1.44 1.43 0 .786.616 1.42 1.43 1.42a1.42 1.42 0 001.44-1.43c0-.786-.616-1.42-1.43-1.42zm.354 1.583l.453.624h-.383l-.407-.573h-.35v.573h-.319V11.81h.748c.391 0 .647.197.647.529.002.271-.158.437-.388.503h-.001zm-.27-.748h-.416v.524h.416c.207 0 .331-.1.331-.262 0-.17-.124-.261-.331-.261z",
      fill: "#1ED760"
    })
  }));
};

var MemoSpotify = /*#__PURE__*/react.memo(Spotify);
/* harmony default export */ var icons_Spotify = (MemoSpotify);
// EXTERNAL MODULE: ./app/components/export-to-playlist/export-to-playlist.module.scss
var export_to_playlist_module = __webpack_require__(8042);
var export_to_playlist_module_default = /*#__PURE__*/__webpack_require__.n(export_to_playlist_module);
// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__(80129);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./app/hooks/lang.ts + 22 modules
var lang = __webpack_require__(91289);
// EXTERNAL MODULE: ./app/components/back-button/back-button.component.tsx
var back_button_component = __webpack_require__(56227);
// EXTERNAL MODULE: ./app/hooks/keyboard-navigation.hook.ts
var keyboard_navigation_hook = __webpack_require__(36158);
// EXTERNAL MODULE: ./app/hooks/go-back.hook.ts
var go_back_hook = __webpack_require__(71014);
// EXTERNAL MODULE: ./node_modules/react-qr-code/lib/index.js
var react_qr_code_lib = __webpack_require__(1653);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useInterval.js
var useInterval = __webpack_require__(43337);
// EXTERNAL MODULE: ./app/utils/is-mobile-resolution.ts + 1 modules
var is_mobile_resolution = __webpack_require__(26089);
// EXTERNAL MODULE: ./app/components/ui/portal.tsx + 1 modules
var portal = __webpack_require__(64263);
// EXTERNAL MODULE: ./app/hooks/modal-scroll.hook.ts
var modal_scroll_hook = __webpack_require__(76299);
;// CONCATENATED MODULE: ./app/components/export-to-playlist/index.tsx




















var StreamingPlatform;

(function (StreamingPlatform) {
  StreamingPlatform["SPOTIFY"] = "SPOTIFY";
  StreamingPlatform["DEEZER"] = "DEEZER";
})(StreamingPlatform || (StreamingPlatform = {}));

var ExportToPlaylistPopup = function ExportToPlaylistPopup(_ref) {
  var _session$user5, _session$user6;

  var onClose = _ref.onClose;
  var t = (0,lang/* useTranslate */.q)();

  var _useFeaturesContext = (0,features_context/* useFeaturesContext */.Pp)(),
      showQRCode = _useFeaturesContext.showQRCode;

  var _useAppSelector = (0,store/* useAppSelector */.CG)(user/* selectUserState */.tH),
      session = _useAppSelector.session;

  var largeDesktop = (0,is_mobile_resolution/* useIsLargeDesktopResolution */.vl)();

  var _useAuth = (0,auth_context/* useAuth */.a)(),
      refreshUserData = _useAuth.refreshUserData;

  (0,useInterval/* default */.Z)(function () {
    var _session$user, _session$user2;

    if (session !== null && session !== void 0 && session.user && (!(session !== null && session !== void 0 && (_session$user = session.user) !== null && _session$user !== void 0 && _session$user.deezer_connect) || !(session !== null && session !== void 0 && (_session$user2 = session.user) !== null && _session$user2 !== void 0 && _session$user2.spotify_connect))) {
      refreshUserData();
    }
  }, 1000);
  (0,react.useEffect)(function () {
    var _session$user3, _session$user4;

    if (session !== null && session !== void 0 && (_session$user3 = session.user) !== null && _session$user3 !== void 0 && _session$user3.deezer_connect || session !== null && session !== void 0 && (_session$user4 = session.user) !== null && _session$user4 !== void 0 && _session$user4.spotify_connect) {
      onClose();
    }
  }, [session === null || session === void 0 ? void 0 : (_session$user5 = session.user) === null || _session$user5 === void 0 ? void 0 : _session$user5.spotify_connect, session === null || session === void 0 ? void 0 : (_session$user6 = session.user) === null || _session$user6 === void 0 ? void 0 : _session$user6.deezer_connect]);

  var loginToSpotify = function loginToSpotify() {
    window.location.href = "https://accounts.spotify.com/authorize?" + lib_default().stringify({
      response_type: "code",
      client_id: "7b20dc3af73847d7b30cdc2042107a7b",
      scope: "user-read-private user-read-email playlist-read playlist-read-private playlist-modify-public playlist-modify-private",
      redirect_uri: "".concat(window.location.origin, "/spotify/"),
      show_dialog: true // state: ,TODO: Add state to prevent CSRF

    });
  };

  var loginToDeezer = function loginToDeezer() {
    window.location.href = "https://connect.deezer.com/oauth/auth.php?" + lib_default().stringify({
      app_id: "529102",
      redirect_uri: "".concat(window.location.origin, "/deezer"),
      perms: "offline_access,manage_library"
    });
  };

  (0,go_back_hook/* useGoBackEvent */.H)("ExportToPlaylist", onClose);
  var wrapperRef = (0,keyboard_navigation_hook/* useArrowKeyNavigationOverlay */.Sy)();
  (0,modal_scroll_hook/* default */.Z)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(portal/* Portal */.h, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (export_to_playlist_module_default()).popup_wrapper,
      ref: wrapperRef,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (export_to_playlist_module_default()).content,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(back_button_component/* BackButtonBar */.K, {
          onClick: onClose
        }), showQRCode ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (export_to_playlist_module_default()).qr_instructions_wrapper,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (export_to_playlist_module_default()).qr_instructions,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
              children: t("playlsit.qr-tutorial.title")
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                children: t("playlsit.qr-tutorial.step1")
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                children: t("playlsit.qr-tutorial.step2")
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                children: t("playlsit.qr-tutorial.step3")
              })]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (export_to_playlist_module_default()).qr_code,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (export_to_playlist_module_default()).qr_wrapper,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(react_qr_code_lib/* default */.Z, {
                value: "https://radioline.co/log-in?redirect=/settings?accountlink=true",
                size: largeDesktop ? 360 : 261
              })
            })
          })]
        }) : /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (export_to_playlist_module_default()).platform_selector,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
            className: (export_to_playlist_module_default()).header,
            children: t("export.select-platform")
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (export_to_playlist_module_default()).platform,
            "data-navigate-row": true,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
              "data-navigate-item": true,
              onClick: function onClick() {
                loginToDeezer();
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(icons_Deezer, {})
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (export_to_playlist_module_default()).platform,
            "data-navigate-row": true,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
              "data-navigate-item": true,
              onClick: function onClick() {
                loginToSpotify();
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(icons_Spotify, {})
            })
          })]
        })]
      })
    })
  });
};
;// CONCATENATED MODULE: ./app/utils/localesMap.ts
var localesMap = {
  en: "English",
  fr: "Français",
  de: "Deutsch",
  es: "Español",
  nl: "Nederlands",
  it: "Italiano",
  pl: "Polski",
  "zh-TW": "繁體中文",
  "zh-CN": "简体中文",
  pt: "Português",
  "pt-BR": "Português Brasileiro",
  se: "Svenska",
  nb: "Norsk",
  ru: "Русский язык",
  ro: "Limba română",
  ja: "日本語",
  ar: "عربي",
  hi: "हिन्दी",
  ko: "한국어"
};
// EXTERNAL MODULE: ./app/components/locale-selector/locale-selector.module.scss
var locale_selector_module = __webpack_require__(94088);
var locale_selector_module_default = /*#__PURE__*/__webpack_require__.n(locale_selector_module);
;// CONCATENATED MODULE: ./app/components/locale-selector/locale-selector.component.tsx












var LocaleSelector = function LocaleSelector(_ref) {
  var onClose = _ref.onClose;
  var wrapperRef = (0,keyboard_navigation_hook/* useArrowKeyNavigationOverlay */.Sy)();
  (0,modal_scroll_hook/* default */.Z)();
  var goBackCallback = (0,react.useCallback)(function () {
    onClose();
  }, [onClose]);
  (0,go_back_hook/* useGoBackEvent */.H)("LocaleSelector", goBackCallback);

  var _useCountryContext = (0,country_context/* useCountryContext */.o)(),
      setLocaleOverride = _useCountryContext.setLocaleOverride;

  var router = (0,next_router.useRouter)();
  var t = (0,lang/* useTranslate */.q)();
  var asPath = router.asPath,
      query = router.query,
      locales = router.locales;
  var userLocales = (locales === null || locales === void 0 ? void 0 : locales.filter(function (item) {
    return !!localesMap[item];
  })) || [];
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (locale_selector_module_default()).popup_wrapper,
    ref: wrapperRef,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (locale_selector_module_default()).content,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(back_button_component/* BackButtonBar */.K, {
        onClick: onClose
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (locale_selector_module_default()).locale_selector,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          className: (locale_selector_module_default()).header,
          children: t("settings.select-application-language")
        }), userLocales === null || userLocales === void 0 ? void 0 : userLocales.map(function (locale) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (locale_selector_module_default()).locale,
            "data-navigate-row": true,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
              className: (locale_selector_module_default()).locale_btn,
              "data-navigate-item": true,
              onClick: function onClick() {
                setLocaleOverride(locale);
                router.push({
                  pathname: "".concat(locale, "/pathname"),
                  query: query
                }, asPath, {
                  locale: locale
                });
                onClose();
              },
              children: localesMap[locale]
            })
          }, "locale-".concat(locale));
        })]
      })]
    })
  });
};
// EXTERNAL MODULE: ./app/hooks/navigation.hook.ts
var navigation_hook = __webpack_require__(26793);
// EXTERNAL MODULE: ./app/utils/getMetaDescription.tsx
var utils_getMetaDescription = __webpack_require__(31549);
;// CONCATENATED MODULE: ./app/components/icons/CheckMarkWide.tsx


function CheckMarkWide_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function CheckMarkWide_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? CheckMarkWide_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CheckMarkWide_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var CheckMarkWide = function CheckMarkWide(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", CheckMarkWide_objectSpread(CheckMarkWide_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 52 37",
    fill: "none"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M16.302 29.192L4.142 17.686 0 21.576 16.302 37 51.297 3.89 47.185 0 16.302 29.192z",
      fill: "#fff"
    })
  }));
};

var MemoCheckMarkWide = /*#__PURE__*/(0,react.memo)(CheckMarkWide);
/* harmony default export */ var icons_CheckMarkWide = (MemoCheckMarkWide);
// EXTERNAL MODULE: ./app/components/toast/toast.component.tsx + 1 modules
var toast_component = __webpack_require__(53483);
// EXTERNAL MODULE: ./app/context/player.context.tsx
var player_context = __webpack_require__(48346);
;// CONCATENATED MODULE: ./pages/settings.tsx


var settings_excluded = ["message", "accountlink"];

































var Settings = function Settings() {
  var _session$user, _session$user2, _session$user3, _session$user4, _session$user6, _session$user7, _session$user9, _session$user10;

  var navigatePath = (0,navigation_hook/* useNavigatePath */.xQ)();
  var router = (0,next_router.useRouter)();
  var t = (0,lang/* useTranslate */.q)();

  var _router$query = router.query,
      message = _router$query.message,
      accountlink = _router$query.accountlink,
      rest = (0,objectWithoutProperties/* default */.Z)(_router$query, settings_excluded);

  var dispatch = (0,store/* useAppDispatch */.TL)();

  var _useCountryContext = (0,country_context/* useCountryContext */.o)(),
      country = _useCountryContext.country,
      setCountry = _useCountryContext.setCountry,
      localeOverride = _useCountryContext.localeOverride;

  var _useAppSelector = (0,store/* useAppSelector */.CG)(user/* selectUserState */.tH),
      session = _useAppSelector.session;

  var _useFeaturesContext = (0,features_context/* useFeaturesContext */.Pp)(),
      appVersion = _useFeaturesContext.appVersion,
      premiumVersion = _useFeaturesContext.premiumVersion,
      forceAutoplay = _useFeaturesContext.forceAutoplay,
      setForceAutoPlay = _useFeaturesContext.setForceAutoPlay,
      showAddDevice = _useFeaturesContext.showAddDevice,
      disableDeleteAccount = _useFeaturesContext.disableDeleteAccount;

  var _useState = (0,react.useState)(false),
      countrySelectorOpen = _useState[0],
      setCountrySelectorOpen = _useState[1];

  var _useState2 = (0,react.useState)(false),
      localeSelectorOpen = _useState2[0],
      setLocaleSelectorOpen = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      exportToPlaylistPopupOpen = _useState3[0],
      setExportToPlaylistPopupOpen = _useState3[1];

  var _useAuth = (0,auth_context/* useAuth */.a)(),
      signOut = _useAuth.signOut,
      refreshUserData = _useAuth.refreshUserData;

  var _useDeletePillowUserV = (0,hooks/* useDeletePillowUserV2UsersMeSpotify */.me)(),
      unlinkSpotify = _useDeletePillowUserV.mutateAsync;

  var _useDeletePillowUserV2 = (0,hooks/* useDeletePillowUserV2UsersMeDeezer */._Q)(),
      unlinkDeezer = _useDeletePillowUserV2.mutateAsync;

  var showMessageAfterRedirection = (0,toast_component/* useToast */.pm)({
    content: message
  });

  var _usePlayerContext = (0,player_context/* usePlayerContext */.gD)(),
      priceData = _usePlayerContext.priceData;

  (0,go_back_hook/* useGoBackHistory */.J)("SETTINGS");
  (0,react.useEffect)(function () {
    if (accountlink) {
      setExportToPlaylistPopupOpen(true);
      router.replace({
        pathname: router.pathname,
        query: rest
      }, undefined, {
        scroll: false
      });
    }
  }, [accountlink]);

  var disconnectSpotify = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var response;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return unlinkSpotify();

            case 3:
              response = _context.sent;
              dispatch(user/* userActions.setUser */.hI.setUser(response.data.data));
              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              refreshUserData();

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }));

    return function disconnectSpotify() {
      return _ref.apply(this, arguments);
    };
  }();

  var disconnectDeezer = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
      var response;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return unlinkDeezer();

            case 3:
              response = _context2.sent;
              dispatch(user/* userActions.setUser */.hI.setUser(response.data.data));
              _context2.next = 10;
              break;

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](0);
              refreshUserData();

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 7]]);
    }));

    return function disconnectDeezer() {
      return _ref2.apply(this, arguments);
    };
  }();

  var linkAccount = function linkAccount() {
    if (session !== null && session !== void 0 && session.user) {
      setExportToPlaylistPopupOpen(true);
    } else {
      navigateLogin();
    }
  };

  var navigateLogin = function navigateLogin() {
    navigatePath("/log-in");
  };

  (0,react.useEffect)(function () {
    refreshUserData();
  }, []);

  var navigatePremium = function navigatePremium() {
    if (!premiumVersion) {
      navigatePath("/get-premium");
    }
  };

  var hasMusicIntegration = !!(session !== null && session !== void 0 && (_session$user = session.user) !== null && _session$user !== void 0 && _session$user.spotify_connect || session !== null && session !== void 0 && (_session$user2 = session.user) !== null && _session$user2 !== void 0 && _session$user2.deezer_connect);

  var disableClick = function disableClick(e) {
    e.preventDefault();
  };

  var getMetaDescription = (0,utils_getMetaDescription/* default */.Z)();
  (0,react.useEffect)(function () {
    if (message) {
      showMessageAfterRedirection();
      router.replace({
        pathname: router.pathname,
        query: rest
      }, undefined, {
        scroll: false
      });
    }
  }, [message]);
  var closeExportToPlaylistCallback = (0,react.useCallback)(function () {
    setExportToPlaylistPopupOpen(false);
  }, [setExportToPlaylistPopupOpen]);
  var closeCountrySelectorCallback = (0,react.useCallback)(function () {
    return setCountrySelectorOpen(false);
  }, [setCountrySelectorOpen]);
  var closeLocaleSelectorCallback = (0,react.useCallback)(function () {
    return setLocaleSelectorOpen(false);
  }, [setLocaleSelectorOpen]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (settings_module_default()).container,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("title", {
          children: [t("settings.settings"), " - Radioline"]
        }), getMetaDescription(t("settings.meta-description"))]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (settings_module_default()).settings_wrapper,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (settings_module_default()).header,
          children: [!(session !== null && session !== void 0 && session.user) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            "data-navigate-row": true,
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(button_component/* Button */.zx, {
              "data-navigate-item": true,
              onClick: function onClick() {
                navigateLogin();
              },
              children: [t("create-an-account"), " / ", t("log-in")]
            })
          }), !premiumVersion && !(session !== null && session !== void 0 && (_session$user3 = session.user) !== null && _session$user3 !== void 0 && _session$user3.premium) && /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "/get-premium",
            passHref: true,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              "data-navigate-row": true,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(button_component/* Button */.zx, {
                accent: true,
                "data-navigate-item": true,
                children: t("premium.go-premium-for", {
                  var1: "".concat(priceData.amount).concat(priceData.currency_symbol)
                })
              })
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
            className: (settings_module_default()).section,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (settings_module_default()).section_header,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                children: t("settings.features")
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (settings_module_default()).features,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                "data-navigate-row": !premiumVersion && !(session !== null && session !== void 0 && (_session$user4 = session.user) !== null && _session$user4 !== void 0 && _session$user4.premium),
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: (settings_module_default()).feature,
                  tabIndex: 0,
                  onClick: function onClick() {
                    var _session$user5;

                    if (!(session !== null && session !== void 0 && (_session$user5 = session.user) !== null && _session$user5 !== void 0 && _session$user5.premium)) {
                      navigatePremium();
                    }
                  },
                  children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: (settings_module_default()).info,
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                      className: (settings_module_default()).title,
                      children: t("settings.no-ads")
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                      className: (settings_module_default()).description,
                      children: t("settings.no-ads-desc")
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: (settings_module_default()).action,
                    children: premiumVersion || !!(session !== null && session !== void 0 && (_session$user6 = session.user) !== null && _session$user6 !== void 0 && _session$user6.premium) ? /*#__PURE__*/(0,jsx_runtime.jsx)(icons_CheckMarkWide, {}) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: (settings_module_default()).toggle_trigger,
                      tabIndex: 0,
                      "data-navigate-item": true,
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Toggle, {
                        disabled: true,
                        checked: premiumVersion || !!(session !== null && session !== void 0 && (_session$user7 = session.user) !== null && _session$user7 !== void 0 && _session$user7.premium)
                      })
                    })
                  })]
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)((settings_module_default()).feature, (settings_module_default()).feature_autoplay),
                "data-navigate-row": true,
                onClick: function onClick() {
                  var _session$user8;

                  if (!(session !== null && session !== void 0 && (_session$user8 = session.user) !== null && _session$user8 !== void 0 && _session$user8.premium)) {
                    navigatePremium();
                  } else {
                    setForceAutoPlay(!forceAutoplay);
                  }
                },
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: (settings_module_default()).info,
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    className: (settings_module_default()).title,
                    children: t("autoplay")
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    className: (settings_module_default()).description,
                    children: t("premium.automatically-play-last-radio")
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: (settings_module_default()).action,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: (settings_module_default()).toggle_trigger,
                    tabIndex: 0,
                    "data-navigate-item": true,
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Toggle, {
                      "data-navigate-target": true,
                      checked: forceAutoplay,
                      onChange: function onChange(e) {
                        return setForceAutoPlay(e.target.checked);
                      },
                      disabled: !premiumVersion && !(session !== null && session !== void 0 && (_session$user9 = session.user) !== null && _session$user9 !== void 0 && _session$user9.premium)
                    })
                  })
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (settings_module_default()).feature,
                "data-navigate-row": true,
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: (settings_module_default()).info,
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    className: (settings_module_default()).title,
                    children: t("export-to-playlist")
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    className: (settings_module_default()).description,
                    children: t("settings.export-to-playlist-desc")
                  }), !hasMusicIntegration ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: (settings_module_default()).music_platforms,
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(icons_Deezer, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(icons_Spotify, {})]
                  }) : /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: (settings_module_default()).music_platforms,
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                      children: t("settings.connected-to")
                    }), session !== null && session !== void 0 && (_session$user10 = session.user) !== null && _session$user10 !== void 0 && _session$user10.spotify_connect ? /*#__PURE__*/(0,jsx_runtime.jsx)(icons_Spotify, {}) : /*#__PURE__*/(0,jsx_runtime.jsx)(icons_Deezer, {})]
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: (0,clsx_m/* default */.Z)((settings_module_default()).action, (settings_module_default()).wide),
                  children: !hasMusicIntegration ? /*#__PURE__*/(0,jsx_runtime.jsx)(button_component/* ButtonOutline */.Ig, {
                    "data-navigate-item": true,
                    onClick: function onClick() {
                      return linkAccount();
                    },
                    children: t("settings.link-account")
                  }) : /*#__PURE__*/(0,jsx_runtime.jsx)(button_component/* ButtonOutline */.Ig, {
                    "data-navigate-item": true,
                    onClick: function onClick() {
                      var _session$user11, _session$user12;

                      if (session !== null && session !== void 0 && (_session$user11 = session.user) !== null && _session$user11 !== void 0 && _session$user11.spotify_connect) {
                        disconnectSpotify();
                      } else if (session !== null && session !== void 0 && (_session$user12 = session.user) !== null && _session$user12 !== void 0 && _session$user12.deezer_connect) {
                        disconnectDeezer();
                      }
                    },
                    children: t("settings.unlink-account")
                  })
                })]
              })]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
            className: (settings_module_default()).section,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (settings_module_default()).section_header,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                children: t("settings.my-app")
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (settings_module_default()).features,
              children: [showAddDevice && /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                href: "/add-device",
                passHref: true,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: (settings_module_default()).feature_link,
                  "data-navigate-row": true,
                  children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: (settings_module_default()).feature,
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: (settings_module_default()).info,
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                        className: (settings_module_default()).title,
                        children: t("settings.add-device")
                      })
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: (settings_module_default()).action,
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                        className: (settings_module_default()).toggle_trigger,
                        "data-navigate-item": true,
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(icons_AngleRight, {
                          className: (settings_module_default()).angle_right
                        })
                      })
                    })]
                  })
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (settings_module_default()).feature,
                "data-navigate-row": true,
                onClick: function onClick() {
                  setLocaleSelectorOpen(true);
                },
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: (settings_module_default()).info,
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    className: (settings_module_default()).title,
                    children: t("settings.application-language")
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    className: (settings_module_default()).description,
                    children: localeOverride ? localesMap[localeOverride] : router.locale ? localesMap[router.locale] : router.locale
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: (settings_module_default()).action,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                    className: (settings_module_default()).toggle_trigger,
                    "data-navigate-item": true,
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(icons_AngleRight, {
                      className: (settings_module_default()).angle_right
                    })
                  })
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (settings_module_default()).feature,
                onClick: function onClick() {
                  return setCountrySelectorOpen(true);
                },
                "data-navigate-row": true,
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: (settings_module_default()).info,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    className: (settings_module_default()).title,
                    children: t("settings.homepage-country")
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: (settings_module_default()).action,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                    "data-navigate-item": true,
                    className: (0,clsx_m/* default */.Z)((settings_module_default()).country_selector, (settings_module_default()).toggle_trigger),
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                      src: country.logo,
                      alt: country.name
                    })
                  })
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                href: "#",
                passHref: true,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: (0,clsx_m/* default */.Z)((settings_module_default()).feature_link, (settings_module_default()).no_hand, (settings_module_default()).app_version_wrapper),
                  onClick: function onClick(e) {
                    return disableClick(e);
                  },
                  children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: (settings_module_default()).feature,
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: (settings_module_default()).info,
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                        className: (settings_module_default()).title,
                        children: t("settings.app-version")
                      })
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: (settings_module_default()).action,
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                        className: (settings_module_default()).app_version,
                        children: appVersion
                      })
                    })]
                  })
                })
              })]
            })]
          }), (session === null || session === void 0 ? void 0 : session.user) && /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
            className: (settings_module_default()).section,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (settings_module_default()).section_header,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                children: t("settings.my-account")
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (settings_module_default()).features,
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (settings_module_default()).feature,
                onClick: function onClick() {
                  return navigatePath("/change-password");
                },
                "data-navigate-row": true,
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: (settings_module_default()).info,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    className: (settings_module_default()).title,
                    children: t("auth.change-my-password")
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: (settings_module_default()).action,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                    className: (settings_module_default()).toggle_trigger,
                    "data-navigate-item": true,
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(icons_AngleRight, {
                      className: (settings_module_default()).angle_right
                    })
                  })
                })]
              }), !disableDeleteAccount && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (settings_module_default()).feature,
                "data-navigate-row": true,
                onClick: function onClick() {
                  return navigatePath("/delete-account");
                },
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: (settings_module_default()).info,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    className: (settings_module_default()).title,
                    children: t("delete-account.button")
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: (settings_module_default()).action,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                    className: (settings_module_default()).toggle_trigger,
                    "data-navigate-item": true,
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(icons_AngleRight, {
                      className: (settings_module_default()).angle_right
                    })
                  })
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (settings_module_default()).feature,
                "data-navigate-row": true,
                onClick: function onClick() {
                  signOut();
                },
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: (settings_module_default()).info,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    className: (settings_module_default()).title,
                    children: t("auth.sign-out")
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: (settings_module_default()).action,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                    className: (settings_module_default()).toggle_trigger,
                    "data-navigate-item": true,
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(icons_AngleRight, {
                      className: (settings_module_default()).angle_right
                    })
                  })
                })]
              })]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
            className: (settings_module_default()).section,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (settings_module_default()).section_header,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                children: "Radioline"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (settings_module_default()).features,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                href: "/contact-us",
                passHref: true,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: (settings_module_default()).feature_link,
                  "data-navigate-row": true,
                  children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: (settings_module_default()).feature,
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: (settings_module_default()).info,
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                        className: (settings_module_default()).title,
                        children: t("contact")
                      })
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: (settings_module_default()).action,
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                        className: (settings_module_default()).toggle_trigger,
                        "data-navigate-item": true,
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(icons_AngleRight, {
                          className: (settings_module_default()).angle_right
                        })
                      })
                    })]
                  })
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                href: "/privacy-policy",
                passHref: true,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: (settings_module_default()).feature_link,
                  "data-navigate-row": true,
                  children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: (settings_module_default()).feature,
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: (settings_module_default()).info,
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                        className: (settings_module_default()).title,
                        children: t("privacy-policy")
                      })
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: (settings_module_default()).action,
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                        className: (settings_module_default()).toggle_trigger,
                        "data-navigate-item": true,
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(icons_AngleRight, {
                          className: (settings_module_default()).angle_right
                        })
                      })
                    })]
                  })
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                href: "/terms-of-use",
                passHref: true,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: (settings_module_default()).feature_link,
                  "data-navigate-row": true,
                  children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: (settings_module_default()).feature,
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: (settings_module_default()).info,
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                        className: (settings_module_default()).title,
                        children: t("terms-of-use")
                      })
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: (settings_module_default()).action,
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                        className: (settings_module_default()).toggle_trigger,
                        "data-navigate-item": true,
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(icons_AngleRight, {
                          className: (settings_module_default()).angle_right
                        })
                      })
                    })]
                  })
                })
              })]
            })]
          })]
        })]
      })]
    }), exportToPlaylistPopupOpen && /*#__PURE__*/(0,jsx_runtime.jsx)(ExportToPlaylistPopup, {
      onClose: closeExportToPlaylistCallback
    }), countrySelectorOpen && /*#__PURE__*/(0,jsx_runtime.jsx)(country_selector_component/* CountrySelector */.P, {
      onClose: closeCountrySelectorCallback,
      onSelect: function onSelect(category) {
        var permalinkSplit = category.permalink.split("/");
        setCountry({
          countryCode: permalinkSplit[permalinkSplit.length - 1],
          logo: category.logo,
          name: category.name,
          permalink: category.permalink,
          preset: false
        });
        setCountrySelectorOpen(false);
      }
    }), localeSelectorOpen && /*#__PURE__*/(0,jsx_runtime.jsx)(LocaleSelector, {
      onClose: closeLocaleSelectorCallback
    }), countrySelectorOpen && /*#__PURE__*/(0,jsx_runtime.jsx)(country_selector_component/* CountrySelector */.P, {
      onClose: function onClose() {
        return setCountrySelectorOpen(false);
      },
      onSelect: function onSelect(category) {
        var permalinkSplit = category.permalink.split("/");
        setCountry({
          countryCode: permalinkSplit[permalinkSplit.length - 1],
          logo: category.logo,
          name: category.name,
          permalink: category.permalink,
          preset: false
        });
        setCountrySelectorOpen(false);
      }
    })]
  });
};

/* harmony default export */ var settings = (Settings);

/***/ }),

/***/ 52837:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/settings",
      function () {
        return __webpack_require__(74904);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 71345:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressColorPrimaryMuted":"rgba(0,0,0,0)","progressColorFill":"#ffca41","progressColorPrimary":"#ffca41","contentMaxWidth":"192rem","back":"back-button_back__KRknK","forgot_button":"back-button_forgot_button__Jmz7Z","wrapper":"back-button_wrapper__cmCKR","absolute":"back-button_absolute__HllSl"};

/***/ }),

/***/ 52986:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressColorPrimaryMuted":"rgba(0,0,0,0)","progressColorFill":"#ffca41","progressColorPrimary":"#ffca41","contentMaxWidth":"192rem","categoryOuterWidth":"25.2rem","wrapper":"category-list_wrapper__1oH1M","header":"category-list_header__pSoNI","premium_label":"category-list_premium_label__wvcuk","buttons":"category-list_buttons__1z2bB","arrow":"category-list_arrow__AdMBS","arrow_back":"category-list_arrow_back__RBMtu","category":"category-list_category__vGBTi","category_list":"category-list_category_list__bqOiw","active":"category-list_active__pqekF","category_img":"category-list_category_img__DiU_c","cover_empty":"category-list_cover_empty__qyxqz","cover_wrapper":"category-list_cover_wrapper__m9WBG","cover":"category-list_cover__cK3He","category_details":"category-list_category_details__KPyrY","category_name":"category-list_category_name__4nFwj","placeholder_item":"category-list_placeholder_item__eRRX9","load":"category-list_load__ezJp5"};

/***/ }),

/***/ 46652:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressColorPrimaryMuted":"rgba(0,0,0,0)","progressColorFill":"#ffca41","progressColorPrimary":"#ffca41","contentMaxWidth":"192rem","countryWidth":"16rem","header":"country-list_header__JOh1w","buttons":"country-list_buttons__Car0k","arrow":"country-list_arrow__IPaMq","arrow_back":"country-list_arrow_back__HfSwM","radio_station":"country-list_radio_station__TNr_V","radio_list":"country-list_radio_list__oigaF","cover":"country-list_cover__6mARf","no_image":"country-list_no_image__6v_GD","station_title":"country-list_station_title__oHN5U","show_station_names":"country-list_show_station_names__pTsO4","row":"country-list_row__K_Plb","wrapped":"country-list_wrapped__xWnqS","placeholder_item":"country-list_placeholder_item__LU4OG","load":"country-list_load__OjEMP"};

/***/ }),

/***/ 42665:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressColorPrimaryMuted":"rgba(0,0,0,0)","progressColorFill":"#ffca41","progressColorPrimary":"#ffca41","contentMaxWidth":"192rem","wrapper":"country-selector_wrapper__cHTYm","content":"country-selector_content__c_Qxw","countries_wrapper":"country-selector_countries_wrapper__teEuO","loader_container":"country-selector_loader_container__D2jsg"};

/***/ }),

/***/ 8042:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressColorPrimaryMuted":"rgba(0,0,0,0)","progressColorFill":"#ffca41","progressColorPrimary":"#ffca41","contentMaxWidth":"192rem","platform":"export-to-playlist_platform__1jvPN","forgot_button":"export-to-playlist_forgot_button__ssymN","popup_wrapper":"export-to-playlist_popup_wrapper__L8peW","content":"export-to-playlist_content__5SxMc","platform_selector":"export-to-playlist_platform_selector__N3kO9","header":"export-to-playlist_header__P_KMD","qr_instructions_wrapper":"export-to-playlist_qr_instructions_wrapper__iW2dj","qr_instructions":"export-to-playlist_qr_instructions__S018W","qr_code":"export-to-playlist_qr_code__M00gj","qr_wrapper":"export-to-playlist_qr_wrapper__EbIXh"};

/***/ }),

/***/ 94088:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressColorPrimaryMuted":"rgba(0,0,0,0)","progressColorFill":"#ffca41","progressColorPrimary":"#ffca41","contentMaxWidth":"192rem","locale":"locale-selector_locale__akSrc","locale_btn":"locale-selector_locale_btn__54WAB","popup_wrapper":"locale-selector_popup_wrapper__fwCMN","content":"locale-selector_content__FqOVw","locale_selector":"locale-selector_locale_selector__xWZbo","header":"locale-selector_header__b4HDb"};

/***/ }),

/***/ 93646:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressColorPrimaryMuted":"rgba(0,0,0,0)","progressColorFill":"#ffca41","progressColorPrimary":"#ffca41","contentMaxWidth":"192rem","podcastOuterWidth":"30rem","podcast":"podcast-list_podcast__8s76E","podcast_img":"podcast-list_podcast_img__tcbGa","placeholder_item":"podcast-list_placeholder_item__aM8sp","header":"podcast-list_header__ii0S7","buttons":"podcast-list_buttons__VFUF0","arrow":"podcast-list_arrow__814ZP","arrow_back":"podcast-list_arrow_back__z2hsB","podcast_list":"podcast-list_podcast_list___Thgh","cover_wrapper":"podcast-list_cover_wrapper__IZfZ7","cover":"podcast-list_cover__GHyYI","no_image":"podcast-list_no_image__lgTwZ","podcast_details":"podcast-list_podcast_details__ZEy0T","podcast_name":"podcast-list_podcast_name__6KtYg","podcast_description":"podcast-list_podcast_description__phzb7","row":"podcast-list_row__0BUuV","load":"podcast-list_load__I13Dy"};

/***/ }),

/***/ 98215:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressColorPrimaryMuted":"rgba(0,0,0,0)","progressColorFill":"#ffca41","progressColorPrimary":"#ffca41","contentMaxWidth":"192rem","radioStationOuterWidth":"18.2rem","radioStationOuterWidthMobile":"12.2rem","wrapper":"stations-list_wrapper__EQsZ_","radio_station":"stations-list_radio_station__V7ZFQ","header":"stations-list_header__WR2Ed","placeholder_item":"stations-list_placeholder_item__S5kXd","station_title":"stations-list_station_title__6tidF","buttons":"stations-list_buttons__dgWsZ","arrow":"stations-list_arrow__hsaxX","arrow_back":"stations-list_arrow_back__srxIO","radio_list":"stations-list_radio_list__nB0CT","cover_wrapper":"stations-list_cover_wrapper__LLHG3","cover":"stations-list_cover__OEgIg","no_image":"stations-list_no_image__3biBe","show_station_names":"stations-list_show_station_names__aW01m","row":"stations-list_row__v4ZLU","vertical":"stations-list_vertical__rnn2R","wrapped":"stations-list_wrapped__lUsyl","load":"stations-list_load__gmj9g"};

/***/ }),

/***/ 13937:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressColorPrimaryMuted":"rgba(0,0,0,0)","progressColorFill":"#ffca41","progressColorPrimary":"#ffca41","contentMaxWidth":"192rem","slider":"toggle_slider__AYkB6","toggle_wrapper":"toggle_toggle_wrapper__NaGzT","reverse":"toggle_reverse__rQNPs","toggle_text":"toggle_toggle_text__CeRQO","small":"toggle_small__Lv745","toggle":"toggle_toggle__g8cIW","disabled":"toggle_disabled__ylTdZ"};

/***/ }),

/***/ 70844:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressColorPrimaryMuted":"rgba(0,0,0,0)","progressColorFill":"#ffca41","progressColorPrimary":"#ffca41","contentMaxWidth":"192rem","toggle_trigger":"settings_toggle_trigger__xNzAL","container":"settings_container__u5R1d","header":"settings_header__zChBE","no_account":"settings_no_account__0FDQA","content":"settings_content__F78_R","title":"settings_title__Fr51P","subtitle":"settings_subtitle__zlf9_","button":"settings_button__5quBD","icon":"settings_icon__fpcnW","settings_wrapper":"settings_settings_wrapper__YvRgN","section":"settings_section__4E5_u","section_header":"settings_section_header__H_GFi","feature_link":"settings_feature_link__kvX_t","feature":"settings_feature__PbjiY","feature_autoplay":"settings_feature_autoplay__DXxtj","info":"settings_info__iq4dE","description":"settings_description___JaaO","action":"settings_action__ye1Cs","wide":"settings_wide__FX4pM","angle_right":"settings_angle_right__3q9ER","app_version":"settings_app_version__qPnVI","app_version_wrapper":"settings_app_version_wrapper__V5lSS","country_selector":"settings_country_selector__b5yeE","music_platforms":"settings_music_platforms__eg52V","selected_locale":"settings_selected_locale__schsT","no_hand":"settings_no_hand__FJu8c","premium_label":"settings_premium_label__kHU_q"};

/***/ }),

/***/ 80792:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressColorPrimaryMuted":"rgba(0,0,0,0)","progressColorFill":"#ffca41","progressColorPrimary":"#ffca41","contentMaxWidth":"192rem"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,7921,6694,8650,9774,2888,179], function() { return __webpack_exec__(52837); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);